//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import LayoutHeader from "../components/layout/Header";
import LayoutAside from "../components/layout/Aside";
import LayoutFooter from "../components/layout/Footer";
import MobileMenu from "../components/layout/mobileMenu.vue"
export default Vue.extend({
  name: "FirstbitDefaultLayout",
  components: {LayoutFooter, LayoutAside, LayoutHeader, MobileMenu},
  head: () => ({
    title: "Личный кабинет абитуриента"
  }),
  data: () => ({
    fixed: false,
  }),
  async fetch(){
    await this.$store.dispatch('competition/init').catch()
    await this.$store.dispatch('initMenuHeader')
  }
})
